import { Box } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import { useListarModelosVeiculo } from "core/features/veiculo/hooks/useListarModelosVeiculo";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

export interface SelectModeloVeiculoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
  marcaId?: string;
}

function SelectModeloVeiculo({
  value,
  onChange,
  isInvalid,
  errorMessage,
  marcaId,
  ...rest
}: SelectModeloVeiculoProps) {
  const [search, setSearch] = useState<string | undefined>();
  const { isLoading, isFetching, data } = useListarModelosVeiculo(marcaId);

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={isLoading || isFetching}
      size="large"
      placeholder="Selecione o modelo"
      style={{ width: "100%", flexGrow: 1, flex: 1 }}
      value={value || undefined}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      notFoundContent={<Box>Nenhum modelo encontrado</Box>}
    />
  );
}

export default SelectModeloVeiculo;
